import { Component, OnInit } from '@angular/core';
import { Moderation } from 'src/app/classes/moderation';
import { ModerationService } from 'src/app/services/moderation.service';
import {SupervisionService} from '../../services/supervision.service';
import { SelectItem } from 'primeng/api';
import * as moment from 'moment';
import {DateCalculationService} from '../../services/date-calculation.service';
import { DialogService } from 'primeng';
import { InvisibleComponent } from './invisible/invisible.component';

@Component({
  selector: 'app-supervision',
  templateUrl: './supervision.component.html',
  styleUrls: ['./supervision.component.css'],
  providers : [DialogService]
})
export class SupervisionComponent implements OnInit {
  barData : any;
  nbTraiteesOptions : any = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ],
      xAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ]
    },
    plugins : {
      datalabels: {
        color : '#000000',
        font: {
          weight:'bold',
          size: 16
        }
      }
    }
  }
  nbTotal  : number = 0;
  collapsedIso = true;
  // DOnnee Tranche A traiter J
  donneeGrapheFicheTrancheJ: any;
  donneeObjetFicheAtraiterJ: any;
  // Donnee Tranche A traiter J+1
  donneeGrapheFicheTrancheJPlus1: any;
  donneeObjetFicheAtraiterJPlus1: any;
  // Donnee Tranche Traiter J
  donneeGrapheFicheTraiteJ: any;
  donneeObjetFicheTraiteJ: any;

  // Donnee Fichier Recues
  donneeGrapheFicheRecue: any;
  optionsGrapheFicheRecue: any = {
    scales: {
      xAxes: [{ stacked: true }],
      yAxes: [{ stacked: true }]
    },
    plugins : {
      datalabels: {
        /* show value in percents */
        formatter: (value, ctx) => {
          return "";
        },
      }
    }
  };
  donneeObjetFicheRecue: any;
  // Donnee Fiches Recues Moyenne Hebdo
  // Donnee Fichier Recues
  donneeGrapheFicheRecueHebdo: any;
  optionsGrapheFicheRecueHebdo: any = {
    scales: {
      xAxes: [{ stacked: true }],
      yAxes: [{ stacked: true }]
    },
    plugins : {
      datalabels: {
        /* show value in percents */
        formatter: (value, ctx) => {
          return "";
        },
      }
    }
  };
  // Donnee Reporting Suivi Global Temps Reel
  nombreFicheRecuesTotal: number;
  dateAujourdhui: string;
  recuLists: any[] = [];
  ListeFicheRecue: string;
  recuCols: any = [ // => Colonnes du tableau TEMPS REEL
    {field: 'mat', header: 'Matricule'},
    {field: 'traiter', header: 'Traitées'},
    {field: 'dmt', header: 'DMT'},
    {field: 'echantillon', header: 'Echantillonnées'},
    {field: 'ko_cq', header: 'KO CQ'},
    {field: 'qualite', header: 'Qualité'},
  ];
  // Donnee Reporting Suivi Global Mensuel
  nombreFicheRecuesTotalMensuel: number;
  moisEC: string;
  globalMensuelLists: any[] = [];
  globalMensuelCols: any = [ // => Colonnes du tableau Suivi Global Temps Reel
    {field: 'mat', header: 'Matricule'},
    {field: 'heffective', header: 'H.effectives'},
    {field: 'htravail', header: 'H.travaillées'},
    {field: 'hmorte', header: 'H.mortes'},
    {field: 'ch', header: 'CH'},
    {field: 'nb_traite', header: 'Nb traitées'},
    {field: 'nb_echantillon', header: 'Nb échantillonnées'},
    {field: 'ko_cq', header: 'KO CQ'},
    {field: 'dmt', header: 'DMT'},
    {field: 'qualite', header: 'Qualité'},
  ];
  complexteFilter: SelectItem[] = [
    {label : 'FORTE', value : 3 },
    {label : 'MOYENNE', value : 2 },
    {label : 'FAIBLE', value : 1 }
  ];



  tauxISoCols:any[] = [{
    field: 'responsable', header:'Opérateur'
  }];
  tauxIsoMensuelListe:any[] = [];
  columnNumber:number = 1; //=> nombre de colonne : utile pour le colspan
  tauxIsoMensuelGrapheData: Object = {
    labels : [],
    datasets : []
  };

  optionsGrapheTauxIso: any = {
    scales: {
      xAxes: [{
        ticks: {
          beginAtZero: true
        }
      }],
      yAxes: [{
        ticks: {
          beginAtZero: false
        }
      }],
    },
    plugins : {
      datalabels: {
        /* show value in percents */
        formatter: (value, ctx) => {
          return "";
        },
      }
    }
  };

  tauxIsoHebdoListe:any[] = [];
  tauxIsoHebdoGrapheData: Object = {
    labels : [],
    datasets : []
  };
  tauxISoHebdoCols:any[] = [{
    field: 'responsable', header:'Opérateur'
  }];

  grapheDelai : Object = {};
  delaiOptions : any = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          },
        }
      ],
      xAxes: [
        {
          ticks: {
            beginAtZero: true
          },
        }
      ]
    },
    plugins : {
      datalabels: {
        color : '#000000',
        font: {
          weight:'bold',
          size: 16
        }
      }
    }
  };
  // Variable Constante
  cadenceContrat: any = [75, 75, 75, 75, 37.5, 37.5, 75, 75, 75, 75];
  listeCouleurTableau: any = [
    {
        "hex": "#EFDECD", 
        "name": "Almond", 
        "rgb": "(239, 222, 205)"
    }, 
    {
        "hex": "#CD9575", 
        "name": "Antique Brass", 
        "rgb": "(205, 149, 117)"
    }, 
    {
        "hex": "#FDD9B5", 
        "name": "Apricot", 
        "rgb": "(253, 217, 181)"
    }, 
    {
        "hex": "#78DBE2", 
        "name": "Aquamarine", 
        "rgb": "(120, 219, 226)"
    }, 
    {
        "hex": "#87A96B", 
        "name": "Asparagus", 
        "rgb": "(135, 169, 107)"
    }, 
    {
        "hex": "#FFA474", 
        "name": "Atomic Tangerine", 
        "rgb": "(255, 164, 116)"
    }, 
    {
        "hex": "#FAE7B5", 
        "name": "Banana Mania", 
        "rgb": "(250, 231, 181)"
    }, 
    {
        "hex": "#9F8170", 
        "name": "Beaver", 
        "rgb": "(159, 129, 112)"
    }, 
    {
        "hex": "#FD7C6E", 
        "name": "Bittersweet", 
        "rgb": "(253, 124, 110)"
    }, 
    {
        "hex": "#000000", 
        "name": "Black", 
        "rgb": "(0,0,0)"
    }, 
    {
        "hex": "#ACE5EE", 
        "name": "Blizzard Blue", 
        "rgb": "(172, 229, 238)"
    }, 
    {
        "hex": "#1F75FE", 
        "name": "Blue", 
        "rgb": "(31, 117, 254)"
    }, 
    {
        "hex": "#A2A2D0", 
        "name": "Blue Bell", 
        "rgb": "(162, 162, 208)"
    }, 
    {
        "hex": "#6699CC", 
        "name": "Blue Gray", 
        "rgb": "(102, 153, 204)"
    }, 
    {
        "hex": "#0D98BA", 
        "name": "Blue Green", 
        "rgb": "(13, 152, 186)"
    }, 
    {
        "hex": "#7366BD", 
        "name": "Blue Violet", 
        "rgb": "(115, 102, 189)"
    }, 
    {
        "hex": "#DE5D83", 
        "name": "Blush", 
        "rgb": "(222, 93, 131)"
    }, 
    {
        "hex": "#CB4154", 
        "name": "Brick Red", 
        "rgb": "(203, 65, 84)"
    }, 
    {
        "hex": "#B4674D", 
        "name": "Brown", 
        "rgb": "(180, 103, 77)"
    }, 
    {
        "hex": "#FF7F49", 
        "name": "Burnt Orange", 
        "rgb": "(255, 127, 73)"
    }, 
    {
        "hex": "#EA7E5D", 
        "name": "Burnt Sienna", 
        "rgb": "(234, 126, 93)"
    }, 
    {
        "hex": "#B0B7C6", 
        "name": "Cadet Blue", 
        "rgb": "(176, 183, 198)"
    }, 
    {
        "hex": "#FFFF99", 
        "name": "Canary", 
        "rgb": "(255, 255, 153)"
    }, 
    {
        "hex": "#1CD3A2", 
        "name": "Caribbean Green", 
        "rgb": "(28, 211, 162)"
    }, 
    {
        "hex": "#FFAACC", 
        "name": "Carnation Pink", 
        "rgb": "(255, 170, 204)"
    }, 
    {
        "hex": "#DD4492", 
        "name": "Cerise", 
        "rgb": "(221, 68, 146)"
    }, 
    {
        "hex": "#1DACD6", 
        "name": "Cerulean", 
        "rgb": "(29, 172, 214)"
    }, 
    {
        "hex": "#BC5D58", 
        "name": "Chestnut", 
        "rgb": "(188, 93, 88)"
    }, 
    {
        "hex": "#DD9475", 
        "name": "Copper", 
        "rgb": "(221, 148, 117)"
    }, 
    {
        "hex": "#9ACEEB", 
        "name": "Cornflower", 
        "rgb": "(154, 206, 235)"
    }, 
    {
        "hex": "#FFBCD9", 
        "name": "Cotton Candy", 
        "rgb": "(255, 188, 217)"
    }, 
    {
        "hex": "#FDDB6D", 
        "name": "Dandelion", 
        "rgb": "(253, 219, 109)"
    }, 
    {
        "hex": "#2B6CC4", 
        "name": "Denim", 
        "rgb": "(43, 108, 196)"
    }, 
    {
        "hex": "#EFCDB8", 
        "name": "Desert Sand", 
        "rgb": "(239, 205, 184)"
    }, 
    {
        "hex": "#6E5160", 
        "name": "Eggplant", 
        "rgb": "(110, 81, 96)"
    }, 
    {
        "hex": "#CEFF1D", 
        "name": "Electric Lime", 
        "rgb": "(206, 255, 29)"
    }, 
    {
        "hex": "#71BC78", 
        "name": "Fern", 
        "rgb": "(113, 188, 120)"
    }, 
    {
        "hex": "#6DAE81", 
        "name": "Forest Green", 
        "rgb": "(109, 174, 129)"
    }, 
    {
        "hex": "#C364C5", 
        "name": "Fuchsia", 
        "rgb": "(195, 100, 197)"
    }, 
    {
        "hex": "#CC6666", 
        "name": "Fuzzy Wuzzy", 
        "rgb": "(204, 102, 102)"
    }, 
    {
        "hex": "#E7C697", 
        "name": "Gold", 
        "rgb": "(231, 198, 151)"
    }, 
    {
        "hex": "#FCD975", 
        "name": "Goldenrod", 
        "rgb": "(252, 217, 117)"
    }, 
    {
        "hex": "#A8E4A0", 
        "name": "Granny Smith Apple", 
        "rgb": "(168, 228, 160)"
    }, 
    {
        "hex": "#95918C", 
        "name": "Gray", 
        "rgb": "(149, 145, 140)"
    }, 
    {
        "hex": "#1CAC78", 
        "name": "Green", 
        "rgb": "(28, 172, 120)"
    }, 
    {
        "hex": "#1164B4", 
        "name": "Green Blue", 
        "rgb": "(17, 100, 180)"
    }, 
    {
        "hex": "#F0E891", 
        "name": "Green Yellow", 
        "rgb": "(240, 232, 145)"
    }, 
    {
        "hex": "#FF1DCE", 
        "name": "Hot Magenta", 
        "rgb": "(255, 29, 206)"
    }, 
    {
        "hex": "#B2EC5D", 
        "name": "Inchworm", 
        "rgb": "(178, 236, 93)"
    }, 
    {
        "hex": "#5D76CB", 
        "name": "Indigo", 
        "rgb": "(93, 118, 203)"
    }, 
    {
        "hex": "#CA3767", 
        "name": "Jazzberry Jam", 
        "rgb": "(202, 55, 103)"
    }, 
    {
        "hex": "#3BB08F", 
        "name": "Jungle Green", 
        "rgb": "(59, 176, 143)"
    }, 
    {
        "hex": "#FEFE22", 
        "name": "Laser Lemon", 
        "rgb": "(254, 254, 34)"
    }, 
    {
        "hex": "#FCB4D5", 
        "name": "Lavender", 
        "rgb": "(252, 180, 213)"
    }, 
    {
        "hex": "#FFF44F", 
        "name": "Lemon Yellow", 
        "rgb": "(255, 244, 79)"
    }, 
    {
        "hex": "#FFBD88", 
        "name": "Macaroni and Cheese", 
        "rgb": "(255, 189, 136)"
    }, 
    {
        "hex": "#F664AF", 
        "name": "Magenta", 
        "rgb": "(246, 100, 175)"
    }, 
    {
        "hex": "#AAF0D1", 
        "name": "Magic Mint", 
        "rgb": "(170, 240, 209)"
    }, 
    {
        "hex": "#CD4A4C", 
        "name": "Mahogany", 
        "rgb": "(205, 74, 76)"
    }, 
    {
        "hex": "#EDD19C", 
        "name": "Maize", 
        "rgb": "(237, 209, 156)"
    }, 
    {
        "hex": "#979AAA", 
        "name": "Manatee", 
        "rgb": "(151, 154, 170)"
    }, 
    {
        "hex": "#FF8243", 
        "name": "Mango Tango", 
        "rgb": "(255, 130, 67)"
    }, 
    {
        "hex": "#C8385A", 
        "name": "Maroon", 
        "rgb": "(200, 56, 90)"
    }, 
    {
        "hex": "#EF98AA", 
        "name": "Mauvelous", 
        "rgb": "(239, 152, 170)"
    }, 
    {
        "hex": "#FDBCB4", 
        "name": "Melon", 
        "rgb": "(253, 188, 180)"
    }, 
    {
        "hex": "#1A4876", 
        "name": "Midnight Blue", 
        "rgb": "(26, 72, 118)"
    }, 
    {
        "hex": "#30BA8F", 
        "name": "Mountain Meadow", 
        "rgb": "(48, 186, 143)"
    }, 
    {
        "hex": "#C54B8C", 
        "name": "Mulberry", 
        "rgb": "(197, 75, 140)"
    }, 
    {
        "hex": "#1974D2", 
        "name": "Navy Blue", 
        "rgb": "(25, 116, 210)"
    }, 
    {
        "hex": "#FFA343", 
        "name": "Neon Carrot", 
        "rgb": "(255, 163, 67)"
    }, 
    {
        "hex": "#BAB86C", 
        "name": "Olive Green", 
        "rgb": "(186, 184, 108)"
    }, 
    {
        "hex": "#FF7538", 
        "name": "Orange", 
        "rgb": "(255, 117, 56)"
    }, 
    {
        "hex": "#FF2B2B", 
        "name": "Orange Red", 
        "rgb": "(255, 43, 43)"
    }, 
    {
        "hex": "#F8D568", 
        "name": "Orange Yellow", 
        "rgb": "(248, 213, 104)"
    }, 
    {
        "hex": "#E6A8D7", 
        "name": "Orchid", 
        "rgb": "(230, 168, 215)"
    }, 
    {
        "hex": "#414A4C", 
        "name": "Outer Space", 
        "rgb": "(65, 74, 76)"
    }, 
    {
        "hex": "#FF6E4A", 
        "name": "Outrageous Orange", 
        "rgb": "(255, 110, 74)"
    }, 
    {
        "hex": "#1CA9C9", 
        "name": "Pacific Blue", 
        "rgb": "(28, 169, 201)"
    }, 
    {
        "hex": "#FFCFAB", 
        "name": "Peach", 
        "rgb": "(255, 207, 171)"
    }, 
    {
        "hex": "#C5D0E6", 
        "name": "Periwinkle", 
        "rgb": "(197, 208, 230)"
    }, 
    {
        "hex": "#FDDDE6", 
        "name": "Piggy Pink", 
        "rgb": "(253, 221, 230)"
    }, 
    {
        "hex": "#158078", 
        "name": "Pine Green", 
        "rgb": "(21, 128, 120)"
    }, 
    {
        "hex": "#FC74FD", 
        "name": "Pink Flamingo", 
        "rgb": "(252, 116, 253)"
    }, 
    {
        "hex": "#F78FA7", 
        "name": "Pink Sherbet", 
        "rgb": "(247, 143, 167)"
    }, 
    {
        "hex": "#8E4585", 
        "name": "Plum", 
        "rgb": "(142, 69, 133)"
    }, 
    {
        "hex": "#7442C8", 
        "name": "Purple Heart", 
        "rgb": "(116, 66, 200)"
    }, 
    {
        "hex": "#9D81BA", 
        "name": "Purple Mountain's Majesty", 
        "rgb": "(157, 129, 186)"
    }, 
    {
        "hex": "#FE4EDA", 
        "name": "Purple Pizzazz", 
        "rgb": "(254, 78, 218)"
    }, 
    {
        "hex": "#FF496C", 
        "name": "Radical Red", 
        "rgb": "(255, 73, 108)"
    }, 
    {
        "hex": "#D68A59", 
        "name": "Raw Sienna", 
        "rgb": "(214, 138, 89)"
    }, 
    {
        "hex": "#714B23", 
        "name": "Raw Umber", 
        "rgb": "(113, 75, 35)"
    }, 
    {
        "hex": "#FF48D0", 
        "name": "Razzle Dazzle Rose", 
        "rgb": "(255, 72, 208)"
    }, 
    {
        "hex": "#E3256B", 
        "name": "Razzmatazz", 
        "rgb": "(227, 37, 107)"
    }, 
    {
        "hex": "#EE204D", 
        "name": "Red", 
        "rgb": "(238,32 ,77 )"
    }, 
    {
        "hex": "#FF5349", 
        "name": "Red Orange", 
        "rgb": "(255, 83, 73)"
    }, 
    {
        "hex": "#C0448F", 
        "name": "Red Violet", 
        "rgb": "(192, 68, 143)"
    }, 
    {
        "hex": "#1FCECB", 
        "name": "Robin's Egg Blue", 
        "rgb": "(31, 206, 203)"
    }, 
    {
        "hex": "#7851A9", 
        "name": "Royal Purple", 
        "rgb": "(120, 81, 169)"
    }, 
    {
        "hex": "#FF9BAA", 
        "name": "Salmon", 
        "rgb": "(255, 155, 170)"
    }, 
    {
        "hex": "#FC2847", 
        "name": "Scarlet", 
        "rgb": "(252, 40, 71)"
    }, 
    {
        "hex": "#76FF7A", 
        "name": "Screamin' Green", 
        "rgb": "(118, 255, 122)"
    }, 
    {
        "hex": "#9FE2BF", 
        "name": "Sea Green", 
        "rgb": "(159, 226, 191)"
    }, 
    {
        "hex": "#A5694F", 
        "name": "Sepia", 
        "rgb": "(165, 105, 79)"
    }, 
    {
        "hex": "#8A795D", 
        "name": "Shadow", 
        "rgb": "(138, 121, 93)"
    }, 
    {
        "hex": "#45CEA2", 
        "name": "Shamrock", 
        "rgb": "(69, 206, 162)"
    }, 
    {
        "hex": "#FB7EFD", 
        "name": "Shocking Pink", 
        "rgb": "(251, 126, 253)"
    }, 
    {
        "hex": "#CDC5C2", 
        "name": "Silver", 
        "rgb": "(205, 197, 194)"
    }, 
    {
        "hex": "#80DAEB", 
        "name": "Sky Blue", 
        "rgb": "(128, 218, 235)"
    }, 
    {
        "hex": "#ECEABE", 
        "name": "Spring Green", 
        "rgb": "(236, 234, 190)"
    }, 
    {
        "hex": "#FFCF48", 
        "name": "Sunglow", 
        "rgb": "(255, 207, 72)"
    }, 
    {
        "hex": "#FD5E53", 
        "name": "Sunset Orange", 
        "rgb": "(253, 94, 83)"
    }, 
    {
        "hex": "#FAA76C", 
        "name": "Tan", 
        "rgb": "(250, 167, 108)"
    }, 
    {
        "hex": "#18A7B5", 
        "name": "Teal Blue", 
        "rgb": "(24, 167, 181)"
    }, 
    {
        "hex": "#EBC7DF", 
        "name": "Thistle", 
        "rgb": "(235, 199, 223)"
    }, 
    {
        "hex": "#FC89AC", 
        "name": "Tickle Me Pink", 
        "rgb": "(252, 137, 172)"
    }, 
    {
        "hex": "#DBD7D2", 
        "name": "Timberwolf", 
        "rgb": "(219, 215, 210)"
    }, 
    {
        "hex": "#17806D", 
        "name": "Tropical Rain Forest", 
        "rgb": "(23, 128, 109)"
    }, 
    {
        "hex": "#DEAA88", 
        "name": "Tumbleweed", 
        "rgb": "(222, 170, 136)"
    }, 
    {
        "hex": "#77DDE7", 
        "name": "Turquoise Blue", 
        "rgb": "(119, 221, 231)"
    }, 
    {
        "hex": "#FFFF66", 
        "name": "Unmellow Yellow", 
        "rgb": "(255, 255, 102)"
    }, 
    {
        "hex": "#926EAE", 
        "name": "Violet (Purple)", 
        "rgb": "(146, 110, 174)"
    }, 
    {
        "hex": "#324AB2", 
        "name": "Violet Blue", 
        "rgb": "(50, 74, 178)"
    }, 
    {
        "hex": "#F75394", 
        "name": "Violet Red", 
        "rgb": "(247, 83, 148)"
    }, 
    {
        "hex": "#FFA089", 
        "name": "Vivid Tangerine", 
        "rgb": "(255, 160, 137)"
    }, 
    {
        "hex": "#8F509D", 
        "name": "Vivid Violet", 
        "rgb": "(143, 80, 157)"
    }, 
    {
        "hex": "#FFFFFF", 
        "name": "White", 
        "rgb": "(255, 255, 255)"
    }, 
    {
        "hex": "#A2ADD0", 
        "name": "Wild Blue Yonder", 
        "rgb": "(162, 173, 208)"
    }, 
    {
        "hex": "#FF43A4", 
        "name": "Wild Strawberry", 
        "rgb": "(255, 67, 164)"
    }, 
    {
        "hex": "#FC6C85", 
        "name": "Wild Watermelon", 
        "rgb": "(252, 108, 133)"
    }, 
    {
        "hex": "#CDA4DE", 
        "name": "Wisteria", 
        "rgb": "(205, 164, 222)"
    }, 
    {
        "hex": "#FCE883", 
        "name": "Yellow", 
        "rgb": "(252, 232, 131)"
    }, 
    {
        "hex": "#C5E384", 
        "name": "Yellow Green", 
        "rgb": "(197, 227, 132)"
    }, 
    {
        "hex": "#FFAE42", 
        "name": "Yellow Orange", 
        "rgb": "(255, 174, 66)"
    }
];

  couleurGlobalISO = '#FF0000';

  constructor(private moderationService: ModerationService, private supervisionService: SupervisionService, private dateService: DateCalculationService, private dialogService : DialogService) {

  }

  ngOnInit(): void {
    this.getAllData();
  }


  getAllData() {
    this.getDateAujourdhuiComplet();
    this.getDataGrapheFicheRecues();
    this.refreshDataPerformanceGlobalReel();
    this.getTauxIsoMensuel();
    this.getDelai();
    this.getTauxHebdo();
    this.getDataGrapheFicheATraiterJ();
    this.getDataGrapheFicheATraiterJPlusUn();
    this.getDataGrapheFicheTraiterJ();
    this.getDataStockEC();
    this.recuLists = [
    ];
    this.nombreFicheRecuesTotal = 0;
    this.nombreFicheRecuesTotalMensuel = 0;
    this.getDataPerformanceGlobalTempReel();
    this.getDataPerformanceGlobalMensuel();
  }
  // Fonction recuperation date aujourdhui
  getDateAujourdhuiComplet() {
    var today = moment().format('YYYY-MM-DD');
    let moisTemp = this.dateService.getCurrentMoisSimple(today);
    let splitTodayTemp = today.split('-');
    //console.log(splitTodayTemp);
    this.dateAujourdhui = splitTodayTemp[2] + ' ' + moisTemp + ' ' + splitTodayTemp[0];
    this.moisEC = moisTemp;
    //console.log(this.dateAujourdhui);
  }
  // Fonction Recuperation Donnee Service Graphe Fiche Recues
  getDataGrapheFicheRecues() {
    this.donneeObjetFicheRecue = {};
    this.supervisionService.getDataGrapheFicheRecues({}).subscribe( (value: any) => {
      if (value.status !== 'success'){
        //console.log('Une erreur dans la requête:' + JSON.stringify(value));
      } else {
        // Assignation DATA Afficher
        ////console.log(value.semaine_moins_un);
        const object = value;
        this.donneeObjetFicheRecue.moyenne_hebdo = object.moyenne_hebdo;
        this.donneeObjetFicheRecue.semaine_moins_deux = object.semaine_moins_deux;
        this.donneeObjetFicheRecue.semaine_moins_un = object.semaine_moins_un;
        this.refreshGrapheRecue();
        this.refreshGrapheRecueHebdo();
      }
    });
  }


  // Fonction Recuperation Donnee Service Graphe Fiche A Traiter J
  getDataGrapheFicheATraiterJ() {
    this.donneeObjetFicheAtraiterJ = {};
    this.supervisionService.getDataGrapheFicheATraiterJ({}).subscribe( (value: any) => {
      if (value.status !== 'success'){
        //console.log('Une erreur dans la requête:' + JSON.stringify(value));
      } else {
        // Assignation DATA Afficher
        ////console.log(value.semaine_moins_un);
        const object = value;
        this.donneeObjetFicheAtraiterJ = object;
        this.refreshGrapheAtraiterParTrancheHeureJ();
      }
    });
  }

  // Fonction Recuperation Donnee Service Graphe Fiche A Traiter J +1
  getDataGrapheFicheATraiterJPlusUn() {
    this.donneeObjetFicheAtraiterJPlus1 = {};
    this.supervisionService.getDataGrapheFicheATraiterJPlusUn({}).subscribe( (value: any) => {
      if (value.status !== 'success'){
        //console.log('Une erreur dans la requête:' + JSON.stringify(value));
      } else {
        // Assignation DATA Afficher
        ////console.log(value.semaine_moins_un);
        const object = value;
        this.donneeObjetFicheAtraiterJPlus1 = object;
        this.refreshGrapheAtraiterParTrancheHeureJPlus1();
      }
    });
  }

  // Fonction Recuperation Donnee Service SUIVI TEMP REEEL
  getDataPerformanceGlobalTempReel() {
    this.recuLists = [];
    this.supervisionService.getSuiviPerformanceGlobalTemps({}).subscribe( (value: any) => {
      if (value.status !== 'success'){
        //console.log('Une erreur dans la requête:' + JSON.stringify(value));
      } else {
        // Assignation DATA Afficher
        ////console.log(value.semaine_moins_un);
        //console.log(value);
        this.nombreFicheRecuesTotal = value.nombre_fiche_recues;
        let arrayPersonne = value.donneePersonne;
        for(let i = 0, maxLengh = arrayPersonne.length; i < maxLengh; i++)
        {
          let objnew =  {
            mat: arrayPersonne[i].id_pers,
            traiter: arrayPersonne[i].nombre_traiter,
            dmt: this.dateService.formatSeconds(arrayPersonne[i].dmt),
            echantillon: arrayPersonne[i].echantillon,
            ko_cq: arrayPersonne[i].ko_cq,
            qualite: arrayPersonne[i].qualite,
          };
          this.recuLists.push(objnew);
        }
      }
    });
  }

  //Fonction Recuperation DOnnee Service Graphe
  getDataPerformanceGlobalMensuel() {
    this.globalMensuelLists = [];
    this.supervisionService.getSuiviPerformanceGlobalMensuel({}).subscribe( (value: any) => {
      if (value.status !== 'success'){
        //console.log('Une erreur dans la requête:' + JSON.stringify(value));
      } else {
        // Assignation DATA Afficher
        ////console.log(value.semaine_moins_un);
        //console.log(value);
        this.nombreFicheRecuesTotalMensuel = value.nombre_fiche_recues;
        let arrayPersonne = value.data;
        // Variable SOMME / MOYENNE GLOBAL MENSUEL
        let totalHeffect = 0;
        let totalHTrav = 0;
        let totalHMorte = 0;
        let totalCH = 0;
        let totalNbTraite = 0;
        let totalNbEchant = 0;
        let totalKOCQ = 0;
        let totalDMT = 0;
        let totalQualite = 0;
        let maxLength = arrayPersonne.length;
        for(let i = 0, maxLengh = arrayPersonne.length; i < maxLengh; i++)
        {
          const ObjTempAssign = arrayPersonne[i];
          totalHeffect= totalHeffect + parseFloat(ObjTempAssign.data_heure_prod.duree_prod_gpao);
          totalHTrav= totalHTrav + parseFloat(ObjTempAssign.data_heure_prod.duree_prod_pointage);
          totalHMorte= totalHMorte + parseFloat(ObjTempAssign.data_heure_prod.duree_pause_gpao);
          totalCH= totalCH + parseFloat(ObjTempAssign.ch);
          totalNbTraite= totalNbTraite + parseFloat(ObjTempAssign.data_mois_actuel.nombre_traiter);
          totalNbEchant= totalNbEchant + parseFloat(ObjTempAssign.data_mois_actuel.echantillon);
          totalKOCQ= totalKOCQ + parseFloat(ObjTempAssign.data_mois_actuel.ko_cq);
          totalDMT= totalDMT + parseFloat(ObjTempAssign.data_mois_actuel.dmt);
          totalQualite= totalQualite + parseFloat(ObjTempAssign.data_mois_actuel.qualite);
          let objnew =  {
           mat: ObjTempAssign.matricule,
           heffective: (ObjTempAssign.data_heure_prod.duree_prod_gpao / 3600).toFixed(2),
           htravail: (ObjTempAssign.data_heure_prod.duree_prod_pointage / 3600).toFixed(2),
           hmorte: (ObjTempAssign.data_heure_prod.duree_pause_gpao / 3600).toFixed(2),
           ch: this.dateService.formatSeconds(ObjTempAssign.ch),
           nb_traite: ObjTempAssign.data_mois_actuel.nombre_traiter,
           nb_echantillon: ObjTempAssign.data_mois_actuel.echantillon,
           ko_cq: ObjTempAssign.data_mois_actuel.ko_cq,
           dmt: this.dateService.formatSeconds(ObjTempAssign.data_mois_actuel.dmt),
           qualite: ObjTempAssign.data_mois_actuel.qualite,
          };
          this.globalMensuelLists.push(objnew);
        }

        if(maxLength > 0) {
          totalDMT = parseFloat((totalDMT / maxLength).toFixed(2));
          totalQualite = parseFloat((totalQualite / maxLength).toFixed(2));
        }

        let objnewGlobal =  {
          mat: 'Global',
          heffective: (totalHeffect / 3600).toFixed(2),
          htravail: (totalHTrav / 3600).toFixed(2),
          hmorte: (totalHMorte / 3600).toFixed(2),
          ch: this.dateService.formatSeconds(totalCH),
          nb_traite: totalNbTraite,
          nb_echantillon: totalNbEchant,
          ko_cq: totalKOCQ,
          dmt: this.dateService.formatSeconds(totalDMT),
          qualite: totalQualite,
        };


        this.globalMensuelLists.push(objnewGlobal);
      }
    });
  }
  // Fonction Recuperation Donnee Service Graphe Fiche A Traiter J +1
  getDataGrapheFicheTraiterJ() {
    this.donneeObjetFicheTraiteJ = {};
    this.supervisionService.getDataGrapheFicheTraiterJ({}).subscribe( (value: any) => {
      if (value.status !== 'success'){
        //console.log('Une erreur dans la requête:' + JSON.stringify(value));
      } else {
        // Assignation DATA Afficher
        ////console.log(value.semaine_moins_un);
        const object = value;
        this.donneeObjetFicheTraiteJ = object;
        this.refreshGrapheTraiterJ();
      }
    });
  }

  // Fonction Changer Graphe Fiche Recues
  refreshGrapheRecue() {
    this.donneeGrapheFicheRecue = {
      labels: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi'],
      datasets: [
        {
          label: 'Faible',
          backgroundColor: '#ff8a09',
          borderColor: '#ff8a09',
          data: [
            Math.floor(this.donneeObjetFicheRecue.semaine_moins_un.lundi.faible), Math.floor(this.donneeObjetFicheRecue.semaine_moins_un.mardi.faible),
            Math.floor(this.donneeObjetFicheRecue.semaine_moins_un.mercredi.faible), Math.floor(this.donneeObjetFicheRecue.semaine_moins_un.jeudi.faible),
            Math.floor(this.donneeObjetFicheRecue.semaine_moins_un.vendredi.faible)]
        },
        {
          label: 'Moyenne',
          backgroundColor: '#85c04c',
          borderColor: '#85c04c',
          data: [
            Math.floor(this.donneeObjetFicheRecue.semaine_moins_un.lundi.moyen), Math.floor(this.donneeObjetFicheRecue.semaine_moins_un.mardi.moyen),
            Math.floor(this.donneeObjetFicheRecue.semaine_moins_un.mercredi.moyen), Math.floor(this.donneeObjetFicheRecue.semaine_moins_un.jeudi.moyen),
            Math.floor(this.donneeObjetFicheRecue.semaine_moins_un.vendredi.moyen)]
        },
        {
          label: 'Forte',
          backgroundColor: '#ab372d',
          borderColor: '#ab372d',
          data: [
            Math.floor(this.donneeObjetFicheRecue.semaine_moins_un.lundi.forte), Math.floor(this.donneeObjetFicheRecue.semaine_moins_un.mardi.forte),
            Math.floor(this.donneeObjetFicheRecue.semaine_moins_un.mercredi.forte), Math.floor(this.donneeObjetFicheRecue.semaine_moins_un.jeudi.forte),
            Math.floor(this.donneeObjetFicheRecue.semaine_moins_un.vendredi.forte)]
        }
      ]
    };
  }

  // Fonction Changer Graphe Fiche Recues MOYENNE HEBDO
  refreshGrapheRecueHebdo() {
    this.donneeGrapheFicheRecueHebdo = {
      labels: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi'],
      datasets: [
        {
          label: 'Faible',
          backgroundColor: '#ff8a09',
          borderColor: '#ff8a09',
          data: [
            Math.floor(this.donneeObjetFicheRecue.moyenne_hebdo.lundi.faible), Math.floor(this.donneeObjetFicheRecue.moyenne_hebdo.mardi.faible),
            Math.floor(this.donneeObjetFicheRecue.moyenne_hebdo.mercredi.faible), Math.floor(this.donneeObjetFicheRecue.moyenne_hebdo.jeudi.faible),
            Math.floor(this.donneeObjetFicheRecue.moyenne_hebdo.vendredi.faible)]
        },
        {
          label: 'Moyenne',
          backgroundColor: '#85c04c',
          borderColor: '#85c04c',
          data: [
            Math.floor(this.donneeObjetFicheRecue.moyenne_hebdo.lundi.moyen), Math.floor(this.donneeObjetFicheRecue.moyenne_hebdo.mardi.moyen),
            Math.floor(this.donneeObjetFicheRecue.moyenne_hebdo.mercredi.moyen), Math.floor(this.donneeObjetFicheRecue.moyenne_hebdo.jeudi.moyen),
            Math.floor(this.donneeObjetFicheRecue.moyenne_hebdo.vendredi.moyen)]
        },
        {
          label: 'Forte',
          backgroundColor: '#ab372d',
          borderColor: '#ab372d',
          data: [
            Math.floor(this.donneeObjetFicheRecue.moyenne_hebdo.lundi.forte), Math.floor(this.donneeObjetFicheRecue.moyenne_hebdo.mardi.forte),
            Math.floor(this.donneeObjetFicheRecue.moyenne_hebdo.mercredi.forte), Math.floor(this.donneeObjetFicheRecue.moyenne_hebdo.jeudi.forte),
            Math.floor(this.donneeObjetFicheRecue.moyenne_hebdo.vendredi.forte)]
        }
      ]
    };
  }

  // Fonction Changer Graphe Fiche A Traiter Par Tranche Heure J
  refreshGrapheAtraiterParTrancheHeureJ() {
    const Cadencediv = this.donneeObjetFicheAtraiterJ.cadence_experience / 2;
    this.donneeGrapheFicheTrancheJ = {
      labels: ['8h_9h', '9h_10h', '10h_11h', '11h_12h', '12h_13h', '13h_14h', '14h_15h', '15h_16h', '16h_17h', '17h_8h J+1'],
      datasets: [
        {
          type: 'line',
          label: 'Cadence Contrat',
          borderColor: '#FF671F',
          borderWidth: 2,
          fill: false,
          data: this.cadenceContrat,
        },
        {
          type: 'line',
          label: 'Cadence Experience',
          borderColor: '#33ff41',
          borderWidth: 2,
          fill: false,
          data: [
            Math.floor(this.donneeObjetFicheAtraiterJ.cadence_experience),
            Math.floor(this.donneeObjetFicheAtraiterJ.cadence_experience),
            Math.floor(this.donneeObjetFicheAtraiterJ.cadence_experience),
            Math.floor(this.donneeObjetFicheAtraiterJ.cadence_experience),
            Math.floor(Cadencediv),
            Math.floor(Cadencediv),
            Math.floor(this.donneeObjetFicheAtraiterJ.cadence_experience),
            Math.floor(this.donneeObjetFicheAtraiterJ.cadence_experience),
            Math.floor(this.donneeObjetFicheAtraiterJ.cadence_experience),
            Math.floor(this.donneeObjetFicheAtraiterJ.cadence_experience)
          ],
        },
        {
          type: 'bar',
          label: 'Nombre Fiches',
          backgroundColor: '#227cff',
          data: [
            Math.floor(this.donneeObjetFicheAtraiterJ.h8_h9),
            Math.floor(this.donneeObjetFicheAtraiterJ.h9_h10),
            Math.floor(this.donneeObjetFicheAtraiterJ.h10_h11),
            Math.floor(this.donneeObjetFicheAtraiterJ.h11_h12),
            Math.floor(this.donneeObjetFicheAtraiterJ.h12_h13),
            Math.floor(this.donneeObjetFicheAtraiterJ.h13_h14),
            Math.floor(this.donneeObjetFicheAtraiterJ.h14_h15),
            Math.floor(this.donneeObjetFicheAtraiterJ.h15_h16),
            Math.floor(this.donneeObjetFicheAtraiterJ.h16_h17),
            Math.floor(this.donneeObjetFicheAtraiterJ.h17_h8D),
          ],
          borderColor: 'white',
          borderWidth: 2
        },
      ]
    };
  }

  // Fonction Changer Graphe Fiche A Traiter Par Tranche Heure J + 1
  refreshGrapheAtraiterParTrancheHeureJPlus1() {
    const Cadencediv = this.donneeObjetFicheAtraiterJPlus1.cadence_experience / 2;
    this.donneeGrapheFicheTrancheJPlus1 = {
      labels: ['8h_9h', '9h_10h', '10h_11h', '11h_12h', '12h_13h', '13h_14h', '14h_15h', '15h_16h', '16h_17h'],
      datasets: [
        {
          type: 'line',
          label: 'Cadence Contrat',
          borderColor: '#FF671F',
          borderWidth: 2,
          fill: false,
          data: this.cadenceContrat,
        },
        {
          type: 'line',
          label: 'Cadence Experience',
          borderColor: '#33ff41',
          borderWidth: 2,
          fill: false,
          data: [
            Math.floor(this.donneeObjetFicheAtraiterJPlus1.cadence_experience),
            Math.floor(this.donneeObjetFicheAtraiterJPlus1.cadence_experience),
            Math.floor(this.donneeObjetFicheAtraiterJPlus1.cadence_experience),
            Math.floor(this.donneeObjetFicheAtraiterJPlus1.cadence_experience),
            Math.floor(Cadencediv),
            Math.floor(Cadencediv),
            Math.floor(this.donneeObjetFicheAtraiterJPlus1.cadence_experience),
            Math.floor(this.donneeObjetFicheAtraiterJPlus1.cadence_experience),
            Math.floor(this.donneeObjetFicheAtraiterJPlus1.cadence_experience)
          ],
        },
        {
          type: 'bar',
          label: 'Nombre Fiches',
          backgroundColor: '#227cff',
          data: [
            Math.floor(this.donneeObjetFicheAtraiterJPlus1.h8_h9),
            Math.floor(this.donneeObjetFicheAtraiterJPlus1.h9_h10),
            Math.floor(this.donneeObjetFicheAtraiterJPlus1.h10_h11),
            Math.floor(this.donneeObjetFicheAtraiterJPlus1.h11_h12),
            Math.floor(this.donneeObjetFicheAtraiterJPlus1.h12_h13),
            Math.floor(this.donneeObjetFicheAtraiterJPlus1.h13_h14),
            Math.floor(this.donneeObjetFicheAtraiterJPlus1.h14_h15),
            Math.floor(this.donneeObjetFicheAtraiterJPlus1.h15_h16),
            Math.floor(this.donneeObjetFicheAtraiterJPlus1.h16_h17)
          ],
          borderColor: 'white',
          borderWidth: 2
        },
      ]
    };
  }

  // Fonction Changer Graphe Fiche Traiter Par Tranche Heure J
  refreshGrapheTraiterJ() {
    const Cadencediv = this.donneeObjetFicheTraiteJ.cadence_experience / 2;
    this.donneeGrapheFicheTraiteJ = {
      labels: ['8h_9h', '9h_10h', '10h_11h', '11h_12h', '12h_13h', '13h_14h', '14h_15h', '15h_16h', '16h_17h'],
/*      datasets: [
        {
          type: 'bar',
          label: 'Dataset 1',
          borderColor: '#FF671F',
          borderWidth: 2,
          fill: false,
          data: [
      /!*      Math.floor(this.donneeObjetFicheTraiteJ.h8_h9),
            Math.floor(this.donneeObjetFicheTraiteJ.h9_h10),
            this.donneeObjetFicheTraiteJ.h10_h11,
            this.donneeObjetFicheTraiteJ.h11_h12,
            this.donneeObjetFicheTraiteJ.h12_h13,
            this.donneeObjetFicheTraiteJ.h13_h14,
            this.donneeObjetFicheTraiteJ.h14_h15,
            this.donneeObjetFicheTraiteJ.h15_h16,
            this.donneeObjetFicheTraiteJ.h16_h17,*!/
      1,2,0,0,0,0,0,0,0
          ],
          order: 1,
        },
        {
          type: 'line',
          label: 'Dataset 2',
          backgroundColor: '#FF671F',
          data: [75,75,75,75,75,75,75,75,75],
          borderColor: 'white',
          borderWidth: 2,
          order: 2,
        },
      ]*/
      datasets: [
        {
          type: 'line',
          label: 'Cadence Contrat',
          borderColor: '#FF671F',
          borderWidth: 2,
          fill: false,
          data: this.cadenceContrat,
        },
        {
          type: 'line',
          label: 'Cadence Experience',
          borderColor: '#33ff41',
          borderWidth: 2,
          fill: false,
          data: [
            Math.floor(this.donneeObjetFicheTraiteJ.cadence_experience),
            Math.floor(this.donneeObjetFicheTraiteJ.cadence_experience),
            Math.floor(this.donneeObjetFicheTraiteJ.cadence_experience),
            Math.floor(this.donneeObjetFicheTraiteJ.cadence_experience),
            Math.floor(Cadencediv),
            Math.floor(Cadencediv),
            Math.floor(this.donneeObjetFicheTraiteJ.cadence_experience),
            Math.floor(this.donneeObjetFicheTraiteJ.cadence_experience),
            Math.floor(this.donneeObjetFicheTraiteJ.cadence_experience)
          ],
        },
        {
          type: 'bar',
          label: 'Nombre Fiches',
          backgroundColor: '#227cff',
          data: [
            Math.floor(this.donneeObjetFicheTraiteJ.h8_h9.nombre),
            Math.floor(this.donneeObjetFicheTraiteJ.h9_h10.nombre),
            Math.floor(this.donneeObjetFicheTraiteJ.h10_h11.nombre),
            Math.floor(this.donneeObjetFicheTraiteJ.h11_h12.nombre),
            Math.floor(this.donneeObjetFicheTraiteJ.h12_h13.nombre),
            Math.floor(this.donneeObjetFicheTraiteJ.h13_h14.nombre),
            Math.floor(this.donneeObjetFicheTraiteJ.h14_h15.nombre),
            Math.floor(this.donneeObjetFicheTraiteJ.h15_h16.nombre),
            Math.floor(this.donneeObjetFicheTraiteJ.h16_h17.nombre)
          ],
        },
        {
          type: 'bar',
          label: 'Fiches en retard',
          backgroundColor: 'indianred',
          borderWidth: 2,
          fill: false,
          data: [
            Math.floor(this.donneeObjetFicheTraiteJ.h8_h9.retard),
            Math.floor(this.donneeObjetFicheTraiteJ.h9_h10.retard),
            Math.floor(this.donneeObjetFicheTraiteJ.h10_h11.retard),
            Math.floor(this.donneeObjetFicheTraiteJ.h11_h12.retard),
            Math.floor(this.donneeObjetFicheTraiteJ.h12_h13.retard),
            Math.floor(this.donneeObjetFicheTraiteJ.h13_h14.retard),
            Math.floor(this.donneeObjetFicheTraiteJ.h14_h15.retard),
            Math.floor(this.donneeObjetFicheTraiteJ.h15_h16.retard),
            Math.floor(this.donneeObjetFicheTraiteJ.h16_h17.retard)
          ],
        },
      ]
    };
  }

  // Set Valeur Tableau Performance Global
  refreshDataPerformanceGlobalReel() {
    this.recuLists= [{
      rubrique: 'Rubrique',
      jour_j: ', header: ',
      objectif: ', header: ',
    },
      {
        rubrique: 'Rubrique',
        jour_j: ', header: ',
        objectif: ', header: ',
      }
    ];
  }


  getTauxIsoMensuel() {
    this.supervisionService.getTauxIsoMensuel().subscribe(value => {
      if(value['status'] !== 'success') {
        //console.log('Une erreur dans la requête:' + value['cause']);
      } else {
        let listeTaux = value['data'];
        let columns = listeTaux.columns;
        let rows = listeTaux.rows;
        this.columnNumber = 1;

        this.buildTauxMensuelDataset(listeTaux);

        for (const currentColumn in columns) {
          if (Object.prototype.hasOwnProperty.call(columns, currentColumn)) {
            this.tauxISoCols.push({
              field: currentColumn, header:currentColumn
            });
            this.columnNumber++;
          }
        }


        for (const currentResp in rows) {
          if (Object.prototype.hasOwnProperty.call(rows, currentResp)) {
            const currentRow = rows[currentResp];
            let object = {
              responsable : currentResp
            };


            for (const currentColValue in currentRow) {
              if (Object.prototype.hasOwnProperty.call(currentRow, currentColValue)) {
                const element = currentRow[currentColValue];
                object[currentColValue] = element['taux'];
              }
            }

            this.tauxIsoMensuelListe.push(object);

          }
        }

      }
    });
  }


  getTauxHebdo() {
    this.supervisionService.getTauxIsoHebdo().subscribe(value => {
      if(value['status'] !== 'success') {
        //console.log('Une erreur dans la requête:' + value['cause']);
      } else {
        let listeTaux = value['data'];
        let columns = listeTaux.columns;
        let rows = listeTaux.rows;
        this.columnNumber = 1;

        this.buildTauxHebdoDataset(listeTaux);

/*        let lastArrayColumn;
        if(columns.length != 0)
        {
          lastArrayColumn = columns[columns.length - 1];
          // GLOBAL FIRST
          this.tauxISoHebdoCols.push({field: lastArrayColumn, header: lastArrayColumn });
          this.columnNumber++;
        }*/

        // NO GLOBAL
        for (const currentColumn in columns) {
          if (Object.prototype.hasOwnProperty.call(columns, currentColumn)) {
            this.tauxISoHebdoCols.push({
              field: currentColumn, header: currentColumn
            });
            this.columnNumber++;
          }
        }


        for (const currentResp in rows) {
          if (Object.prototype.hasOwnProperty.call(rows, currentResp)) {
            const currentRow = rows[currentResp];
            let object = {
              responsable : currentResp
            };


            for (const currentColValue in currentRow) {
              if (Object.prototype.hasOwnProperty.call(currentRow, currentColValue)) {
                const element = currentRow[currentColValue];
                object[currentColValue] = element['taux'];
              }
            }

            this.tauxIsoHebdoListe.push(object);

          }
        }

      }
    });
  }


  buildTauxMensuelDataset(listeTaux:Object) {
    let labels = [''];
    let dataset = [];
    let rows = listeTaux['rows'];

    let columns = Object.keys(listeTaux['columns']);

    columns.forEach(current => {
      labels.push(current);
    });
    labels.push('');

    let tableauLength = 0;
    let index_color =0;
    
    for (const currentResponsable in rows) {
      if (Object.prototype.hasOwnProperty.call(rows, currentResponsable)) {
        const element = rows[currentResponsable];
        let valeurCouleur = '';
        if(currentResponsable  === 'Global')
        {
          //console.log("passe"+index_color);
          valeurCouleur = this.couleurGlobalISO;
        }else
        {
          valeurCouleur = this.listeCouleurTableau[index_color].hex
        }
        let currentDataset = {
          label : currentResponsable,
          borderColor : valeurCouleur,
          //lineTension: 1,
          fill: false
        };
        let tableauData = new Array(columns.length);
        tableauData[0] = null;
        tableauData[(tableauData.length - 1)] = null;

        for (const key in element) {
          if (Object.prototype.hasOwnProperty.call(element, key)) {
            const currentDateValue = element[key];
            let index = labels.indexOf(key);
            tableauData[index] = currentDateValue.taux;
          }
        }

        currentDataset['data'] = tableauData;
        dataset.push(currentDataset);
        tableauLength = tableauData.length;
        index_color++;
      }
    }
    let arrDash= [];
    for(let i = 0;i<=index_color;i++)
    {
      arrDash.push(98.5);
    }
    dataset.push({
      label: 'Objectif ',
      data: arrDash,
      borderDash: [10, 5]
    });
    this.tauxIsoMensuelGrapheData = {
      labels : labels,
      datasets : dataset
    };
  }


  buildTauxHebdoDataset(listeTaux:Object) {
    let labels = [''];
    let dataset = [];
    let rows = listeTaux['rows'];

    let columns = Object.keys(listeTaux['columns']);
    //console.log(columns);

    columns.forEach(current => {
      labels.push(current);
    });

    labels.push('');

    let tableauLength = 0;
    let index_color = 0;

    for (const currentResponsable in rows) {
      if (Object.prototype.hasOwnProperty.call(rows, currentResponsable)) {
        const element = rows[currentResponsable];
        let valeurCouleur = '';
        if(currentResponsable  === 'Global')
        {
          //console.log("passe"+index_color);
          valeurCouleur = this.couleurGlobalISO;
        }else
        {
          valeurCouleur = this.listeCouleurTableau[index_color].hex
        }
        let currentDataset = {
          label : currentResponsable,
          borderColor : valeurCouleur,
          //lineTension: 1,
          fill:false
        };
        let tableauData = new Array(columns.length);
        tableauData[0] = null;
        tableauData[(tableauData.length - 1)] = null;

        for (const key in element) {
          if (Object.prototype.hasOwnProperty.call(element, key)) {
            const currentDateValue = element[key];
            let index = labels.indexOf(key);
            tableauData[index] = currentDateValue.taux;
          }
        }

        currentDataset['data'] = tableauData;
        dataset.push(currentDataset);
        tableauLength = tableauData.length;
        index_color++;
      }

    }
    let arrDash= [];

    for(let i = 0;i<=tableauLength;i++)
    {
      arrDash.push(98.5);
    }
    dataset.push({
      label: 'Objectif ',
      data: arrDash,
      borderDash: [10, 5]
    });
    this.tauxIsoHebdoGrapheData = {
      labels : labels,
      datasets : dataset
    };
  }


  getDelai() {
    this.supervisionService.getDelai().subscribe( value => {
      if(value['status'] !== 'success') {
        //console.log('Une erreur dans la requête:' + value['cause']);
      } else {
        let datasetsValue = value['data'];

        this.grapheDelai = {
          labels : ['1h<', '>1h;2h<', '>2h;3h<', '>3h;4h<', '>4h;5h<', '>5h;6h<', '>6h;7h<', '>7h;8h<', '>8h'],
          datasets: [{
            label: 'Volume de fiches à traiter',
            backgroundColor: '#30acec',
            borderColor: '#30acec',
            data: [
              datasetsValue['0'], datasetsValue['1'], datasetsValue['2'], datasetsValue['3'], datasetsValue['4'], datasetsValue['5'], datasetsValue['6'], datasetsValue['7'], datasetsValue['8']
            ]
          }],
        };

        //console.log(this.grapheDelai);
      }
    });
  }

  generateRandomHexaColor() {
    let n = (Math.random() * 0xfffff * 1000000).toString(16);
    return '#' + n.slice(0, 6);
  }


  showListePersonne() {
    const ref = this.dialogService.open(InvisibleComponent, {
      header: 'Filtre des personnes',
      width: '40%',
      // data: {
      //   moderation:moderation
      // }
    });


    ref.onDestroy.subscribe(() => {
      this.refreshDataPerformanceGlobalReel();
      this.getDataPerformanceGlobalTempReel();
    });
  }

  // Fonction recuperation graphe stock
  getDataStockEC() {
    this.supervisionService.getNbStockEC().subscribe( value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
      }else {
        let results = value["data"];
        console.log(results);
        this.nbTotal = Number(results.Faible) + Number(results.Moyenne) + Number(results.Forte);

        this.barData = {
          labels: [''],
          datasets : [
            {
              label: 'Faible',
              backgroundColor: '#6495ED',
              borderColor: '#1E88E5',
              data: [results.Faible]
            },
            {
              label: 'Moyenne',
              backgroundColor: '#FF8C00',
              borderColor: '#1E88E5',
              data: [results.Moyenne]
            },
            {
              label: 'Forte',
              backgroundColor: '#A9A9A9',
              borderColor: '#1E88E5',
              data: [results.Forte]
            },
          ]

        }
      }
    });
  }
}
